import React, { useContext } from 'react';
import AddToCartButtons from '../AddToCart/AddToCartButtons.jsx';
import { Voucher } from '../../services/Constants/ObjectDefinitions.js';
import PropTypeShapes from '../../services/Constants/PropTypeShapes.jsx';
import PropTypes from 'prop-types';
import StockStatus from '../../services/Constants/StockStatus.js';
import { SubscriptionDetailsContext } from '../../services/context/SubscriptionDetailsContext.js';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import { blockedStatuses } from '../../services/Constants/config.js';
/**
 * @param {object} props - the props of the component
 * @param {Voucher} props.voucher - the voucher to check
 * @param {JSX.Element} props.isClubVoucher - vodapay club voucher check
 * @returns {JSX.Element} StockChecker component
 */
export default function StockChecker({ voucher, isClubVoucher = false }) {
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const navigateTo = useNavigate();
  const { expiryDate, isSubscribed, subscriptionStatus } = subscriptionDetails || {};

  // Helper function to handle the club voucher logic
  const shouldDisplayClubButton = () => expiryDate && !isSubscribed && !blockedStatuses.includes(subscriptionStatus);

  const shouldDisplayAddToCart = () => {
    if (isClubVoucher) {
      return !blockedStatuses.includes(subscriptionStatus) && voucher.stock.status === StockStatus.inStock;
    }

    return voucher.stock.status === StockStatus.inStock;
  };

  // Handle club voucher case
  if (isClubVoucher) {
    if (shouldDisplayClubButton()) {
      return (
        <button
          className='secondary-button'
          onClick={ () => navigateTo(ROUTES.VODAPAY_CLUB) }
        >
          Join the club
        </button>
      );
    }

    if (!expiryDate && !isSubscribed) {
      return null;
    }
  }

  if (shouldDisplayAddToCart()) {
    return <AddToCartButtons voucher={ voucher } />;
  }

  return <> {voucher.stock.status !== StockStatus.inStock ? 'Out of stock' : null} </>;
}

StockChecker.propTypes = {
  voucher: PropTypeShapes.voucher,
  isClubVoucher: PropTypes.bool,
};
